import React, { useState, useEffect } from 'react';
import { MdWifiOff } from 'react-icons/md';
import connectionMonitor from '../../utils/connectionMonitor';
import useTranslation from '../hooks/useTranslation';

const OfflineBanner = () => {
    const [isOnline, setIsOnline] = useState(connectionMonitor.getStatus());
    const translation = useTranslation();

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        connectionMonitor.on('online', handleOnline);
        connectionMonitor.on('offline', handleOffline);

        // Initial check
        setIsOnline(connectionMonitor.getStatus());

        return () => {
            connectionMonitor.off('online', handleOnline);
            connectionMonitor.off('offline', handleOffline);
        };
    }, []);

    if (isOnline) {
        return null;
    }

    return (
        <div
            className="fixed left-1/2 z-[9999] w-max max-w-[95vw] -translate-x-1/2 rounded-b-xl bg-orange-500 px-4 py-1.5 text-center text-white shadow-lg"
            style={{ top: "32px" }}
        >
            <div className="flex items-center justify-center gap-2">
                <MdWifiOff size={17} />
                <p className="text-sm font-bold">
                    {translation.offlineNotification || "Offline working mode"}
                </p>
            </div>
        </div>
    );
};

export default OfflineBanner;
